// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.volcanoPlot.hover {\n    cursor: pointer;\n}\n.gene-on-clicked-dot-volcano {\n    display: block;\n    float: left;\n    padding: 0 5px;\n}\n", ""]);
// Exports
module.exports = exports;
